import React from "react";
import PropTypes from "prop-types";
import Avatar from "../Avatar";

const UserOption = ({ id, name, email, isAdmin }) => {
    return (
        <div className="user-select--option">
            <div className="user-select--option--user-name">
                <div>
                    <Avatar name={name} small />
                    {name}
                </div>
                {isAdmin && <small className="user-select--admin-flag bg--white text--grey">Admin</small>}
            </div>
            <small className="user-select--email">{email}</small>
        </div>
    );
};

UserOption.propTypes = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    isAdmin: PropTypes.bool,
};

UserOption.defaultProps = {
    isAdmin: false,
};

export default UserOption;
